export default __webpack_public_path__ + "static/media/icon__16.12b06860.svg";